import type {Validation, ValidationRuleWithoutParams, ValidationRuleWithParams, ErrorObject} from '@vuelidate/core';
import {unref} from 'vue';
import {getDutchError} from '~/lib/dutchValidatorMessages';
import type {FormElementItem, GroupFormElementItem} from '~/lib/types/formTypes';

/**
 * Vuelidate validator rule
 *
 * [Build in validation rules]{@link https://vuelidate-next.netlify.app/validators.html}
 * [How-to add custom validation rules]{@link https://vuelidate-next.netlify.app/custom_validators.html}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type VuelidateValidationRule = ValidationRuleWithParams<any, any> | ValidationRuleWithoutParams;
type Validators = Record<string, VuelidateValidationRule>

export default () => {
	const getValidations = (formSchema: Array<FormElementItem>) => {
		const thisRules: Record<string, Validators> = {};

		formSchema.forEach(item => {
			if (item.type === 'group' && item.fields) {
				item.fields.forEach(childItem => {
					thisRules[childItem.key] = childItem.validators;
				});
			} else {
				thisRules[item.key] = item.validators;
			}
		});

		return thisRules;
	};

	const getErrors = (itemKey: string, vuelidate: Validation) => {
		return vuelidate[itemKey]?.$errors.map(($error: ErrorObject) => {
			return unref<string>(getDutchError($error));
		}) ?? [];
	};

	const getGroupErrors = <T>(item: GroupFormElementItem<T>, vuelidate: Validation) => {
		return vuelidate.$errors
			.filter(($error: ErrorObject) => {
				return item.fields?.some(childItem => childItem.key === $error.$property);
			})
			.map(($error: ErrorObject) => {
				return unref<string>(getDutchError($error));
			});
	};

	return {
		getErrors,
		getGroupErrors,
		getValidations
	};
};
